import { createSlice } from '@reduxjs/toolkit';

const systemSettingFilterSlice = createSlice({
    name: 'systemSettingFilter',
    initialState: {
        isLoading: true,
        isError: false,
        error: false,
        getModule: [],
        getTypes: [],
    },
    reducers: {
        fetchModuleOption: (state, action) => {
            state.getModule = action.payload;
            state.isLoading = false;
        },
        fetchModuleOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },

        
        fetchTypeOption: (state, action) => {
            state.getTypes = action.payload;
            state.isLoading = false;
        },
        fetchTypeOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
    },
});

export const {
    fetchModuleOption,
    fetchModuleOptionError,
    fetchTypeOption,
    fetchTypeOptionError,
} = systemSettingFilterSlice.actions;

export default systemSettingFilterSlice.reducer;